// src/common/UI/TokenRefreshModal/index.tsx
"use client";

import React from "react";
import { Loader2, X, LogOut, RotateCw } from "lucide-react";
import styles from "./TokenRefreshModal.module.css";
import sessionExpiredImage from "../../../assets/images/sessionExpired.png";

interface TokenRefreshModalProps {
  isOpen: boolean;
  onClose: () => void;     // -> aquí haremos logout
  onRefresh: () => void;
  isLoading: boolean;
}

export default function TokenRefreshModal({
  isOpen,
  onClose,
  onRefresh,
  isLoading,
}: TokenRefreshModalProps) {
  if (!isOpen) return null;

  return (
    <div className={styles.overlay} role="dialog" aria-modal="true" aria-labelledby="session-title">
      <div className={styles.dialog}>
        {/* Header */}
        <div className={styles.dialogHeader}>
          <button className={styles.closeButton} onClick={onClose} aria-label="Cerrar sesión">
            <X className={styles.closeIcon} />
          </button>
          <img
            src={sessionExpiredImage}
            alt="Advertencia de sesión"
            className={styles.headerImage}
          />
          <h2 id="session-title" className={styles.dialogTitle}>Sesión expirada</h2>
          <p className={styles.dialogDescription}>
            Tu token ha expirado. ¿Deseas refrescar tu sesión para continuar?
          </p>
        </div>

        {/* Footer */}
        <div className={styles.dialogFooter}>
          <button
            className={`${styles.button} ${styles.buttonPrimary}`}
            onClick={onRefresh}
            disabled={isLoading}
          >
            {isLoading ? (
              <Loader2 className={styles.loaderIcon} />
            ) : (
              <RotateCw className={styles.buttonIcon} />
            )}
            Refrescar sesión
          </button>

          <button
            className={`${styles.button} ${styles.buttonOutline}`}
            onClick={onClose}
            disabled={isLoading}
          >
            <LogOut className={styles.buttonIcon} />
            Cerrar sesión
          </button>
        </div>
      </div>
    </div>
  );
}
